import { birthdateFromAge } from '@@serverHelpers/index.mjs';
import {
  isRenteConjointRequired,
  isSpouseRequired
} from '@@viewHelpers/validations/guaranteesPrevTns.js';
import { filter, propEq, propOr } from 'ramda';

const useNiveauxGarantiesTarifsPrevTnsRenteConjointForm = ({
  form,
  guarantees,
  getMiddleNumber,
  getMiddleText
}) => {
  const rConj = form.watch('guarantees.OPTION_RCONJ.selected');
  const spouse = form.watch('spouse');

  const { OPTION_RCONJ, RCONJ_MAD, RCONJ_CAP } = guarantees;

  const addSpouse = () => {
    form.setValue('spouse', { birthDate: null, editing: true, type: 'SPOUSE' });
    form.trigger();
  };

  const setEditingSpouse = (editing) => {
    form.setValue('spouse', { ...spouse, editing: editing });
  };

  const deleteSpouse = async () => {
    await form.setValue('spouse', null);
    form.trigger();
  };

  const minSpouseAge = getMiddleNumber('BENEFICIAIRE_DATE_NAISSANCE_AGE_MINIMUM_SPOUSE');
  let maxSpouseBirthDate = null;
  if (minSpouseAge > -1) {
    maxSpouseBirthDate = birthdateFromAge(
      minSpouseAge,
      form.watch('offer.effectDate'),
      getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_TYPE_CALCUL_AGE'),
      false
    );
  }
  const maxSpouseAge = getMiddleNumber('BENEFICIAIRE_DATE_NAISSANCE_AGE_MAXIMUM_SPOUSE');
  let minSpouseBirthDate = null;
  if (maxSpouseAge > -1) {
    minSpouseBirthDate = birthdateFromAge(
      maxSpouseAge,
      form.watch('offer.effectDate'),
      getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_TYPE_CALCUL_AGE'),
      true
    );
  }

  const renteConjointCotisation = [
    {
      displayed: rConj,
      label: getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_RCONJ_LABEL'),
      monthlyAmount: propOr(0.0, 'monthlyPrice', RCONJ_CAP),
      yearlyAmount: propOr(0.0, 'annualPrice', RCONJ_CAP)
    }
  ];

  return {
    rConj,
    minSpouseAge,
    maxSpouseAge,
    minSpouseBirthDate,
    maxSpouseBirthDate,
    spouse,
    addSpouse,
    setEditingSpouse,
    deleteSpouse,
    isSpouseRequired,
    isRenteConjointRequired,
    OPTION_RCONJ,
    RCONJ_MAD,
    renteConjointCotisation: filter(propEq('displayed', true), renteConjointCotisation)
  };
};

export default useNiveauxGarantiesTarifsPrevTnsRenteConjointForm;
